import { TaskStatus } from "@quickcommerceltd/zephyr-types";

export const TASK_COMPLETE_STATUSES: TaskStatus[] = ["DELIVERED", "FAILED"];
